/**
 * The layout system's semantic breakpoints, in px. Single source of truth:
 * tailwind.config.ts builds its `screens` from these, and runtime code that
 * needs a media query flipping exactly where the markup's `tablet:` /
 * `desktop:` classes do (AdSlot's minViewport gate, HeroShowcase's ad
 * mounting split) imports them instead of re-hardcoding the values.
 */
export const SCREENS = {
  tablet: 768,
  desktop: 1280,
} as const

export type ScreenName = keyof typeof SCREENS

export const minWidthQuery = (screen: ScreenName): string =>
  `(min-width: ${SCREENS[screen]}px)`
